import { COMPANIES } from "../data/brand";

/**
 * Auto-scrolling infinite marquee showing insurance companies we work with.
 * Pure CSS animation — duplicates the list 2x for seamless loop (translateX 0 -> -50%).
 * Companies without `direct: true` show a small "Tramite Collaborazioni Orizzontali" caption.
 */
export default function CompaniesSlider() {
  const list = [...COMPANIES, ...COMPANIES];

  return (
    <section
      data-testid="companies-section"
      className="bg-white border-y border-slate-200 py-20 lg:py-24 overflow-hidden"
    >
      <div className="container-90 mb-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
          <div className="lg:col-span-7">
            <div className="overline mb-4">Le nostre partnership</div>
            <h2 className="font-heading text-3xl sm:text-5xl font-extrabold tracking-tight text-slate-900 leading-[1.05]">
              Le compagnie con cui
              <br />
              <span className="text-[color:var(--brand-blue)]">lavoriamo ogni giorno.</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-slate-600 leading-relaxed max-w-md lg:ml-auto">
              Confronto diretto e tramite collaborazioni orizzontali tra intermediari, per
              offrirti sempre la soluzione migliore in trasparenza e qualità delle garanzie.
            </p>
          </div>
        </div>
      </div>

      <div className="marquee py-2" data-testid="companies-marquee">
        <div className="marquee-track gap-4 pr-4">
          {list.map((c, i) => (
            <CompanyCard
              key={`row1-${i}`}
              name={c.name}
              direct={!!c.direct}
              testId={`company-${c.id}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

function CompanyCard({ name, direct, testId }) {
  return (
    <div
      data-testid={testId}
      className="group flex flex-col items-center justify-center min-w-[230px] h-28 px-8 bg-slate-50 border border-slate-200 hover:border-[color:var(--brand-blue)] hover:bg-white transition-all"
    >
      <span className="font-heading text-xl lg:text-2xl font-extrabold tracking-tight text-slate-700 group-hover:text-[color:var(--brand-blue)] transition-colors whitespace-nowrap leading-none">
        {name}
      </span>
      {!direct && (
        <span
          data-testid={`${testId}-collab-label`}
          className="mt-2 text-[0.62rem] uppercase tracking-[0.18em] font-semibold text-slate-400 whitespace-nowrap"
        >
          Tramite Collaborazioni Orizzontali
        </span>
      )}
    </div>
  );
}
